import { Navigate } from 'react-router-dom';
import { canAccessUsersModule } from '../utils/permissions';
import { useAuth } from '../context/AuthContext';

function ManagementRoute({ children }) {
  const { user, loading } = useAuth();

  if (loading) {
    return null;
  }

  if (!canAccessUsersModule(user)) {
    return <Navigate to="/dashboard" replace />;
  }

  return children;
}

export default ManagementRoute;

